<!-- [color]="'primary'" [color]="'accent'" [color]="'warn'" -->

<mat-progress-spinner
  [color]="'accent'"
  [strokeWidth]="15"
  [diameter]="100"
  [mode]="'indeterminate'"></mat-progress-spinner>
